export enum UserDocumentTabType {
  documentsToBeApproved = 1,
  imDocument = 2,
  termsSheet = 3,
  myDrive = 4,
  other = 5,
  financialDocs = 6,
  legalDocs = 7,
}

export const UserDocumentTabTypeText: Record<UserDocumentTabType, string> = {
  [UserDocumentTabType.documentsToBeApproved]: "Documents to be approved",
  [UserDocumentTabType.imDocument]: "IM Document",
  [UserDocumentTabType.termsSheet]: "Terms Sheet",
  [UserDocumentTabType.myDrive]: "My Drive",
  [UserDocumentTabType.other]: "Other",
  [UserDocumentTabType.financialDocs]: "Financial Docs",
  [UserDocumentTabType.legalDocs]: "Legal Docs",
};
